import { render } from "./statDashboard.vue?vue&type=template&id=68a30d7a&scoped=true"
import script from "./statDashboard.vue?vue&type=script&lang=js"
export * from "./statDashboard.vue?vue&type=script&lang=js"

import "./statDashboard.vue?vue&type=style&index=0&id=68a30d7a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68a30d7a"]])

export default __exports__